<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div *ngIf="!loading">
    <div class="flex-grow-1">
    <div class="row summary-row">
        <div class="col-12">
            <app-summary-totals [summaryData]="summaryData"></app-summary-totals>
        </div>
    </div>
    <div class="row flex-grow-1">
        <div id="containers" class="col-md-5 col-12 pr-1 flex-grow-1 d-flex flex-column" appSetHeight [overflow]="'hidden'">
            <div class="row">
                <div class="col-11" [hidden]="!locationId && !selectedLocationId">
                    <mat-form-field appearance="fill" style="width: 20%">
                        <mat-label>Container</mat-label>
                        <mat-select [(value)]="selectedContainerId" (selectionChange)="containerChange($event.value)">
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let constainer of containerList" [value]="constainer.id">{{constainer.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" style="width: 24%" class="ml-1">
                        <mat-label>Type</mat-label>
                        <mat-select [(value)]="selectedContainerTypeId" (selectionChange)="typeChange($event.value)">
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let type of typeList" [value]="type.id">{{type.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" style="width: 40%" class="ml-1">
                        <mat-label>Status</mat-label>
                        <mat-select [(value)]="selectedStatusId" (selectionChange)="statusChange($event.value)">
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let status of statusList" [value]="status.id">{{status.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="overflow-auto pt-2">
                <div class="table-box">
                    <div class="row w-100 assets">
                        <p [hidden]="locationId || selectedLocationId">Please specify a location to see the list of containers</p>
                        <div class="col-12" [hidden]="!locationId && !selectedLocationId">
                            <table>
                                <thead>
                                    <th>Container</th>
                                    <th>Type</th>
                                    <th>On Site</th>
                                    <th>Status</th>
                                    <th></th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let asset of filteredAssetsOnSite; let i = index;">
                                        <td>{{ asset.id }}</td>
                                        <td>{{ asset.type }}</td>
                                        <td>{{ asset.daysOnSite }}</td>
                                        <td>{{ asset.statusDisplay }}</td>
                                        <td class="pl-2">
                                            <span class="container-icon text-primary me-2 me-md-0 relative-top--2" (click)="openPopup(asset.assetURL === null ? 'https://pinwebsiteimages.blob.core.windows.net/binreportimages/10000_OPN_image_front.jpg' : asset.assetURL)">
                                                <img src="/img/RoRo.png" *ngIf="asset.assetTypeClassification == 0">
                                                <img src="/img/Skip.png" *ngIf="asset.assetTypeClassification == 1">
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- <ng-container *ngFor="let asset of assetsOnSite; let i = index;">
                            <div class="item col-6 d-flex align-items-stretch">
                                <div class="card m-1 w-100">
                                    
                                    <table class="asset-item">
                                        <tr *ngIf="asset.order">
                                            <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Contract:</td>
                                            <td class="value">{{ asset.order }} </td>
                                        </tr>
                                        <tr>
                                            <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Container:</td>
                                            <td class="value">{{ asset.id }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Type:</td>
                                            <td class="value">{{ asset.type }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">On Site:</td>
                                            <td class="value">{{ asset.daysOnSite }}</td>
                                        </tr>
                                        <tr *ngIf="asset.isIntegration">
                                            <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Waste Type:</td>
                                            <td class="value">{{ asset.wasteTypeName }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </ng-container> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-7 col-12 pl-1 flex-grow-1 d-flex flex-column" appSetHeight [padding]="20" [overflow]="'auto'">
        <div id="filters" class="row pt-2">
            <div class="col-12">
                <mat-form-field appearance="fill" [hidden]="locationId || !regionList || regionList.length == 0 || selectedRegionId" style="width: 20%">
                    <mat-label>Region</mat-label>
                    <mat-select [(value)]="selectedRegionId" (selectionChange)="regionChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let region of regionList" [value]="region.id">{{region.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" [hidden]="locationId || selectedDepotId" style="width: 24%">
                    <mat-label>Depot</mat-label>
                    <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let depot of depotList" [value]="depot.id">{{depot.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" [hidden]="locationId || selectedLocationId" style="width: 40%">
                    <mat-label>Location</mat-label>
                    <mat-select [(value)]="selectedLocationId" (selectionChange)="locationChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let location of locationList" [value]="location.id">{{location.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" hidden style="width: 16%">
                    <mat-label>Show</mat-label>
                    <mat-select [(value)]="selectedShowSetting" (selectionChange)="showSettingChange($event.value)">
                        <mat-option>All</mat-option>
                        <mat-option value={{ShowSetting[ShowSetting.Surplus]}}>Surplus</mat-option>
                        <mat-option value={{ShowSetting[ShowSetting.Deficit]}}>Deficit</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" hidden style="width: 20%">
                    <mat-label>Status</mat-label>
                    <mat-select [(value)]="selectedDamageStatus" (selectionChange)="damageStatusChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option value={{DamageStatus[DamageStatus.InService]}}>In Service</mat-option>
                        <mat-option value={{DamageStatus[DamageStatus.Damaged]}}>Damaged</mat-option>
                        <mat-option value={{DamageStatus[DamageStatus.DamagedInService]}}>Damaged In Service</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-12 pl-0 pr-0 flex-grow-1">
            <div class="h-100 overflow-auto">
                <div class="col-12 summary pl-0">
                    <div id="report">
                        <div id="roros" *ngIf="data?.roros && data.roros.length > 0">
                            <h5>RoRo</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                <tr>
                                    <th class="group">
                                    </th>
                                    <th class="type">
                                        DEPOT
                                    </th>
                                    <th class="type">
                                        YARD
                                    </th>
                                    <th class="type">
                                        DAMAGED
                                    </th>
                                    <th class="type">
                                        AVAILABLE
                                    </th>
                                    <th class="type">
                                        USAGE
                                    </th>
                                    <th class="type">
                                        ADJUST
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">REQUIRED</span>
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                    </th>
<!--                                     <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">4 WEEK %</span>
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">12 WEEK %</span>
                                    </th> -->
                                </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let group of data.roros">
                                        <tr>
                                            <td class="category">
                                                <div class="innerWrapper">
                                                    <div [hidden]="group.name == 'Total'" (click)="toggleRow(group.name + '|' + group.category)" class="controls"><i *ngIf="group.assetTypes?.length && !expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">add</i><i *ngIf="group.assetTypes?.length && expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">remove</i></div>
                                                    <span class="reference">{{ group.name }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.depotCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.yardCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.damagedCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.availableCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.requiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.adjustCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netRequiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.netSurplusColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netSurplusCount }}</span>
                                                </div> 
                                            </td>
<!--                                             <td class="column" [ngStyle]="{'color': group.fourWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.fourWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.twelveWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.twelveWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td> -->
                                        </tr>
                                        <ng-container *ngIf="expandedCategories.includes(group.name + '|' + group.category)">
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                            <ng-container *ngFor="let assetType of group.assetTypes">
                                                <tr>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="reference">{{ assetType.name }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.depotCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.yardCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.damagedCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.availableCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.requiredCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.adjustCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.netRequiredCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.netSurplusCount }}</span>
                                                        </div> 
                                                    </td>
<!--                                                     <td class="default" [ngStyle]="{'color': assetType.fourWeeksTrendPercentageColor}">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.fourWeeksTrendPercentageDisplay }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default" [ngStyle]="{'color': assetType.twelveWeeksTrendPercentageColor}">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.twelveWeeksTrendPercentageDisplay }}</span>
                                                        </div> 
                                                    </td> -->
                                                </tr>
                                            </ng-container>
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div id="skips" *ngIf="data?.skips && data.skips.length > 0">
                            <h5>Skip</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                    <tr>
                                        <th class="group">
                                        </th>
                                        <th class="type">
                                            DEPOT
                                        </th>
                                        <th class="type">
                                            YARD
                                        </th>
                                        <th class="type">
                                            DAMAGED
                                        </th>
                                        <th class="type">
                                            AVAILABLE
                                        </th>
                                        <th class="type">
                                            USAGE
                                        </th>
                                        <th class="type">
                                            ADJUST
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">REQUIRED</span>
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                        </th>                                        
<!--                                         <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">4 WEEK %</span>
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">12 WEEK %</span>
                                        </th> -->
                                    </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let group of data.skips">
                                        <tr>
                                            <td class="category">
                                                <div class="innerWrapper">
                                                    <div [hidden]="group.name == 'Total'" (click)="toggleRow(group.name + '|' + group.category)" class="controls"><i *ngIf="group.assetTypes?.length && !expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">add</i><i *ngIf="group.assetTypes?.length && expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">remove</i></div>
                                                    <span class="reference">{{ group.name }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.depotCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.yardCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.damagedCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.availableCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.requiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.adjustCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netRequiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.netSurplusColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netSurplusCount }}</span>
                                                </div> 
                                            </td>
<!--                                             <td class="column" [ngStyle]="{'color': group.fourWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.fourWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.twelveWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.twelveWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td> -->
                                        </tr>
                                        <ng-container *ngIf="expandedCategories.includes(group.name + '|' + group.category)">
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                            <ng-container *ngFor="let assetType of group.assetTypes">
                                                <tr>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="reference">{{ assetType.name }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.depotCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.yardCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.damagedCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.availableCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.requiredCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.adjustCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.netRequiredCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.netSurplusCount }}</span>
                                                        </div> 
                                                    </td>
<!--                                                     <td class="default" [ngStyle]="{'color': assetType.fourWeeksTrendPercentageColor}">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.fourWeeksTrendPercentageDisplay }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default" [ngStyle]="{'color': assetType.twelveWeeksTrendPercentageColor}">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.twelveWeeksTrendPercentageDisplay }}</span>
                                                        </div> 
                                                    </td> -->
                                                </tr>
                                            </ng-container>
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div id="others" *ngIf="data?.others && data.others.length > 0" hidden>
                            <h5>Ungrouped</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                    <tr>
                                        <th class="group">
                                        </th>
                                        <th class="type">
                                            DEPOT
                                        </th>
                                        <th class="type">
                                            YARD
                                        </th>
                                        <th class="type">
                                            DAMAGED
                                        </th>
                                        <th class="type">
                                            AVAILABLE
                                        </th>
                                        <th class="type">
                                            USAGE
                                        </th>
                                        <th class="type">
                                            ADJUST
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">REQUIRED</span>
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                        </th>
<!--                                         <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">4 WEEK %</span>
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">12 WEEK %</span>
                                        </th> -->
                                    </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let group of data.others">
                                        <tr>
                                            <td class="category">
                                                <div class="innerWrapper">
                                                    <span class="reference">{{ group.name }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.depotCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.yardCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.damagedCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.availableCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.requiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.adjustCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netRequiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.netSurplusColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netSurplusCount }}</span>
                                                </div> 
                                            </td>
<!--                                             <td class="column" [ngStyle]="{'color': group.fourWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.fourWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.twelveWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.twelveWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td> -->
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div id="damage" *ngIf="damage && damage.length > 0">
                            <h5>Damage</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                <tr>
                                    <th class="container">
                                        CONTAINER
                                    </th>
                                    <th class="status">
                                        STATUS
                                    </th>
                                    <th class="status">
                                        FAULT
                                    </th>
                                    <th class="status">
                                        LOCATION
                                    </th>
                                    <th class="small" title="VOR Time">
                                        DAYS
                                    </th>
                                    <th class="small" title="Click link for details">
                                        MORE
                                    </th>
                                </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let item of damage">
                                        <tr>
                                            <td class="container" title="{{ item.assetId }}">
                                                <div class="innerWrapper">
                                                    <div (click)="toggleDamage(item.id)" class="controls"><i *ngIf="!expandedDamage.includes(item.id)" class="material-icons">add</i><i *ngIf="expandedDamage.includes(item.id)" class="material-icons">remove</i></div>
                                                    <span class="reference">{{ item.assetId }}</span>
                                                </div> 
                                            </td>
                                            <td class="status" title="{{ item.statusDescription }}">
                                                <div class="innerWrapper">
                                                    <span class="default">{{item.statusDescription }}</span>
                                                </div> 
                                            </td>
                                            <td class="status" title="{{ item.faultDescription }}">
                                                <div class="innerWrapper">
                                                    <span class="default">{{item.faultDescription }}</span>
                                                </div> 
                                            </td>
                                            <td class="email" title="{{ item.currentLocation }}">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ item.currentLocation }}</span>
                                                </div> 
                                            </td>
                                            <td class="small">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ item.numberOfDays }}</span>
                                                </div> 
                                            </td>
                                            <td class="small">
                                                <div class="innerWrapper">
                                                    <a href="/damage/{{item.assetId}}" target="_blank">⧉</a>
                                                </div> 
                                            </td>
                                        </tr>
                                        <ng-container *ngIf="expandedDamage.includes(item.id)">
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                            <tr>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="reference">Reported:</span>
                                                    </div> 
                                                </td>
                                                <td class="container">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ item.reportedDisplayDate }}</span>
                                                    </div> 
                                                </td>
                                            </tr>
                                            <tr [hidden]="!item.sentForRepairDisplayDate">
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="reference">Assessed:</span>
                                                    </div> 
                                                </td>
                                                <td class="container">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ item.sentForRepairDisplayDate }}</span>
                                                    </div> 
                                                </td>
                                            </tr>
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                        </ng-container>                                        
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
        </div>
        </div>
    </div>
    </div>
</div>
<app-image-popup [imageSrc]="selectedImage" [isOpen]="isPopupOpen" (close)="closePopup()"></app-image-popup>